import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

export const statusTemplate = (rowData) => {
    const isActive = rowData.data.activa === true;
    return (
        <Tag
            value={isActive ? "Activo" : "Inactivo"}
            severity={isActive ? "success" : "warning"}
        />
    );
};

export const actionTemplate = (rowData, { onEditar, onEliminar, onToggle, onVerProductos, loading }) => {
    const isActive = rowData.data.activa === true;
    return (
        <div className="flex gap-2 align-items-center">
            <Button
                icon="pi pi-pencil"
                tooltip="Editar"
                tooltipOptions={{ position: "top" }}
                onClick={() => onEditar?.(rowData.data)}
                size="small"
                disabled={loading || !isActive}
                outlined
            />
            <Button
                icon="pi pi-box"
                tooltip="Ver productos"
                tooltipOptions={{ position: "top" }}
                onClick={() => onVerProductos?.(rowData.data)}
                size="small"
                severity="info"
                disabled={loading || !isActive}
                outlined
            />
            <Button
                icon="pi pi-power-off"
                tooltip={isActive ? "Desactivar" : "Activar"}
                tooltipOptions={{ position: "top" }}
                onClick={() => onToggle?.(rowData.data, !isActive)}
                size="small"
                severity={isActive ? "warning" : "success"}
                outlined
            />
            <Button
                size="small"
                severity="danger"
                icon="pi pi-trash"
                outlined
                tooltip="Eliminar"
                tooltipOptions={{ position: "top" }}
                onClick={() => onEliminar?.(rowData.data)}
            />
        </div>
    );
};